import { isEqual } from 'es-toolkit';

export function toggleArrayValues<T>(
  values: T[],
  value: T,
  comparator: (value: T, other: T) => boolean = isEqual
): T[] {
  const existing = values.find((v) => comparator(v, value));
  return existing ? values.filter((v) => !comparator(v, value)) : [...values, value];
}
